import React from "react";
import useReveal from "@/hooks/useReveal";
import { Calendar, Globe, CheckCircle, Headphones, ShieldCheck } from "@phosphor-icons/react";
import { useI18n } from "@/context/LangContext";

const ITEMS = [
  { icon: Calendar, k: "15+ yrs", vKey: "trust.years" },
  { icon: Globe, k: "10+", vKey: "trust.countries" },
  { icon: CheckCircle, k: "50+", vKey: "trust.impl" },
  { icon: Headphones, k: "24×7", vKey: "trust.support" },
  { icon: ShieldCheck, k: "ISO 27001", vKey: "trust.iso" },
];

export default function GlobalTrustStrip() {
  const ref = useReveal();
  const { t } = useI18n();
  return (
    <section
      ref={ref}
      data-testid="global-trust-strip"
      className="reveal bg-[color:var(--ink)] text-white border-y border-[color:var(--ink)]"
    >
      <div className="container-x py-6">
        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5 md:gap-8">
          {ITEMS.map(({ icon: I, k, vKey }) => (
            <li key={vKey} data-testid={`trust-item-${vKey.split(".").pop()}`} className="flex items-center gap-3">
              <div className="shrink-0 w-9 h-9 border border-white/25 flex items-center justify-center">
                <I size={18} weight="bold" className="text-[color:var(--brand)]" />
              </div>
              <div className="leading-tight">
                <div className="font-display font-black text-base md:text-lg tracking-tight">{k}</div>
                <div className="font-mono text-[9px] uppercase tracking-widest text-white/60">{t(vKey)}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
